import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { HEADER_PADDING_MOBILE } from '~/cards/components/CardListing/CardListing.styles';
import { FilterPills } from './FilterPills';

export const FilterContainer = styled.div`
  position: relative;
  margin: 0 -${HEADER_PADDING_MOBILE};
`;

export const Filters = styled.div`
  display: flex;
  overflow-x: auto;
  column-gap: ${SPACING.XS};
  padding: 0 ${HEADER_PADDING_MOBILE};
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledFilterPills = styled(FilterPills)`
  padding: 0 ${HEADER_PADDING_MOBILE};
`;
